import { jwtDecode } from 'jwt-decode'

const state = {
  isLoggedIn: !!sessionStorage.getItem('token'),
  token: sessionStorage.getItem('token')
}

const getters = {
  isLoggedIn: state => state.token !== null,
  token: state => state.token,
  currentUser: state => {
    if (state.token === null || state.token === undefined) return null
    try {
      return jwtDecode(state.token)
    } catch (e) {
      return null
    }
  }
}

const actions = {
  setToken ({ commit }, token) {
    commit('setToken', token)
  },
  deleteToken ({ commit }) {
    commit('deleteToken')
  }
}

const mutations = {
  setToken (state, token) {
    state.token = token
    sessionStorage.setItem('token', token)
  },
  deleteToken (state) {
    state.token = null
    sessionStorage.removeItem('token')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
